import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { AuthDataDispatcher } from '../../../auth-data/auth-data.dispatcher';
import { AuthDataStore } from '../../../auth-data/auth-data.store';
import { I2gNgTrackingActionBuilder } from 'i2g-ng-tracking';
import { TrackingObjectBuilder } from '../../../tracking/tracking-object.builder';
import {
  ITrackingAction,
  ITrackingObject,
  TrackingScreenNamesEnum,
} from '../../../tracking/tracking.data';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-logout',
  templateUrl: 'logout.component.html',
  styleUrls: ['logout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoutComponent implements OnInit {
  @Input() userEmail: string;

  loggingOut: boolean;
  trackingObject: ITrackingObject;
  signedOutAction: ITrackingAction;

  constructor(
    private _authDataStore: AuthDataStore,
    private _authDataDispatcher: AuthDataDispatcher,
    private _trackingActionBuilder: I2gNgTrackingActionBuilder,
    private _trackingObjectBuilder: TrackingObjectBuilder
  ) {}

  ngOnInit() {
    this.signedOutAction = this._trackingActionBuilder.buildSignedOut(
      TrackingScreenNamesEnum.account_sign_in
    );

    forkJoin(
      this._authDataStore.getAccountId(),
      this._authDataStore.getUserId()
    ).subscribe(([accountId, userId]) => {
      this.trackingObject = this._trackingObjectBuilder.buildAccount(
        this.userEmail,
        accountId,
        userId
      );
    });
  }

  logout() {
    if (!this.loggingOut) {
      this.loggingOut = true;

      this._authDataDispatcher.logout();
    }
  }
}
